import type { RefundsListRow } from "@/admin/entities/refunds";
import type { RefundsListQueryType } from "@/types/graphql/admin.generated";

export function getTableData(data: unknown): {
  nodes: RefundsListRow[];
  count: number;
} {
  const refunds = (data as RefundsListQueryType)?.refunds;
  if (!refunds || !refunds.nodes) {
    return { nodes: [], count: 0 };
  }
  return refunds;
}

export function mapColumns(refund: RefundsListRow) {
  return [
    refund.id,
    refund.amount,
    refund.amount.valueUSD,
    refund.ottkitFeeAmount?.valueUSD,
    refund.organizationAmount?.valueUSD,
    refund,
    refund,
    refund,
    refund,
    refund,
    refund,
    refund.createdAt,
  ];
}
